import type { OrderListItemItem } from '@skupreme/api-contracts/core';
import { Image } from '@skupreme/shared/ui';
import { sizedImage } from '../../../../lib/listingImage';

export type OrderLineImages = Pick<OrderListItemItem, 'item_id' | 'p_images'>;

/**
 * The picture of the order's first line that has one, with how many other
 * distinct items the order has as a "+N" on its corner. With no picture on any
 * line, or one that fails to load, it shows the placeholder.
 */
export function OrderItemsThumbCell({ items }: { items: OrderLineImages[] }) {
  const withImage = items.find(line => line.p_images?.display_image?.trim());
  const more = new Set(items.map(line => line.item_id)).size - 1;

  return (
    <span className="sk:relative sk:inline-flex">
      <Image
        src={sizedImage(withImage?.p_images?.display_image?.trim(), 'thumb')}
        alt=""
        size="sm"
        fit="contain"
        loading="lazy"
      />
      {more > 0 ? (
        <span
          title={`${more} more ${more === 1 ? 'item' : 'items'}`}
          className="sk:absolute sk:-right-2 sk:-bottom-1.5 sk:rounded-full sk:bg-fill-secondary sk:px-1 sk:text-xs sk:font-medium sk:text-fg-secondary sk:inset-shadow-hairline"
        >
          +{more}
        </span>
      ) : null}
    </span>
  );
}
